var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPhone2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Phone-Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Style-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "style-guide",
    transform: "translate(-1088.000000, -10880.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(60.000000, 10295.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(1028.000000, 585.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0828594,11.7892914 L21.2304091,16.2862013 L16.8978271,21.2310969 L16.3441011,21.1344061 C12.3386458,20.4349793 9.12483846,18.8921572 6.73162408,16.4987057 C4.33841601,14.1052604 2.79583794,10.8912348 2.09664799,6.88556773 L2,6.3318703 L6.94420667,2 L11.4411084,7.14754038 L9.59872446,9.52930863 C9.918569,10.6008699 10.416291,11.4663991 11.0901459,12.1402539 C11.7640007,12.8141088 12.6295299,13.3118308 13.7010912,13.6316753 L16.0828594,11.7892914 Z M8.14590771,15.0845622 C10.1245395,17.0633901 12.7808471,18.3911439 16.1395621,19.0616426 L18.4062018,16.4746641 L16.0056514,14.3775385 L14.1537079,15.8100838 L13.6875778,15.6981699 C12.0592269,15.3072167 10.7149696,14.5935048 9.6759323,13.5544675 C8.63689496,12.5154302 7.92318313,11.1711729 7.53222986,9.54282202 L7.42031597,9.07669196 L8.85286133,7.2247484 L6.75572751,4.8241887 L4.16939013,7.09021009 C4.83968911,10.4491743 6.16725758,13.105716 8.14590771,15.0845622 Z",
    id: "Shape",
    fill: "#191919",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPhone2);
export default __webpack_public_path__ + "static/media/ico_phone2.dcc6a1e4434924fa62f3e1a9d11bd194.svg";
export { ForwardRef as ReactComponent };